import { assignSafe } from '@summit/core';
import { RoleAccess } from './policies/role-access.enum';

export class OtherParameters {
  hasLocalShop: boolean;
  financialAccess: RoleAccess;
  disputeAccess: RoleAccess;

  constructor(jsonData?: Partial<OtherParameters>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    this.hasLocalShop ??= null;
    this.financialAccess ??= null;
    this.disputeAccess ??= null;
  }

  isEquivalent(other: OtherParameters): boolean {
    return (
      this.hasLocalShop === other.hasLocalShop &&
      this.financialAccess === other.financialAccess &&
      this.disputeAccess === other.disputeAccess
    );
  }

  setCorporateDefaults() {
    this.hasLocalShop ??= false;
    this.financialAccess ??= RoleAccess.BackOfficeAndAbove;
  }
}
